module.exports = __webpack_public_path__ + "assets/img/btn-back-4c729060.png";